import React from 'react';
import './Overview.scss';

const Overview: React.FC = () => {
  return (
    <div className="overview">
      <section className="page-hero">
        <div className="container">
          <h1>ग्रामपंचायतीची संक्षिप्त माहिती</h1>
          <p className="subtitle">तांडा ग्रामपंचायतीबद्दलची महत्त्वाची माहिती</p>
        </div>
      </section>
      {/* <div className="breadcrumb-bar">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>ग्रामपंचायतीची संक्षिप्त माहिती</span>
          </nav>
        </div>
      </div> */}

      <section className="container content">
        <h2>ग्रामाचा परिचय</h2>
        <p>
          तांडा ग्रामपंचायत गोंदिया तालुक्यातील एक प्रगतिशील ग्रामपंचायत आहे. ग्रामवासियांच्या
          सर्वांगीण विकासासाठी मूलभूत सुविधा, पायाभूत सुविधा, शिक्षण, आरोग्य व सामाजिक सुरक्षा
          या सर्व क्षेत्रात सातत्याने काम करण्याचा ग्रामपंचायतीचा प्रयत्न आहे.
        </p>

        <div className="grid">
          <div className="card">
            <h3>लोकसंख्या</h3>
            <p>2782 लोकसंख्या (नवीन जनगणनेनुसार बदल होऊ शकतो)</p>
          </div>
          <div className="card">
            <h3>प्राथमिक सुविधा</h3>
            <p>स्वच्छ पिण्याचे पाणी, रस्ता, वीज, स्वच्छता व सार्वजनिक इमारती</p>
          </div>
          <div className="card">
            <h3>शैक्षणिक संस्था</h3>
            <p>ग्रामपंचायत अंतर्गत १ ते 7 वी पर्यंत शाळा तसेच जवळच्या ठिकाणी माध्यमिक शिक्षण</p>
          </div>
        </div>
      </section>

      <section className="container content">
        <h2>प्रशासन व शासन व्यवस्था</h2>
        <p>
          ग्रामपंचायत ही ग्रामस्तरावरची लोकप्रतिनिधी संस्था असून सरपंच, उपसरपंच व सदस्य यांच्या
          मार्गदर्शनाखाली ग्रामविकासाची कामे राबविली जातात. विविध कायम समित्या व विषय समित्यांच्या
          माध्यमातून कामकाज पार पाडले जाते.
        </p>
        <div className="grid">
          <div className="card">
            <h3>ग्रामसभा</h3>
            <p>
              वर्षभरात किमान चार ग्रामसभा घेऊन विविध योजना, खर्च, निर्णय व समस्या यांवर चर्चा करून
              सामूहिक निर्णय घेतले जातात.
            </p>
          </div>
          <div className="card">
            <h3>समित्या</h3>
            <p>
              तंटामुक्ती समिती, जलव्यवस्थापन समिती, ग्रामस्वच्छता व आरोग्य समिती, शिक्षण समिती आदी
              समित्यांच्या माध्यमातून नागरिकांचा सहभाग सुनिश्चित केला जातो.
            </p>
          </div>
          <div className="card">
            <h3>पारदर्शकता</h3>
            <p>
              आय-व्यय हिशोब, मंजूर योजना, मंजूर कामे, टेंडर प्रक्रिया इत्यादी माहिती ग्रामपंचायत
              कार्यालयात तसेच सूचना फलकावर उपलब्ध करून देण्यात येते.
            </p>
          </div>
        </div>
      </section>

      <section className="container content">
        <h2>विकासाचे प्रमुख क्षेत्र</h2>
        <p>
          तांडा ग्रामपंचायतने पुढील काही वर्षांसाठी ठराविक विकास आराखडा तयार केला असून खालील क्षेत्रांना
          विशेष प्राधान्य देण्यात आले आहे.
        </p>
        <div className="grid">
          <div className="card">
            <h3>पायाभूत सुविधा</h3>
            <p>
              अंतर्गत रस्त्यांचे मजबुतीकरण, सार्वजनिक प्रकाशव्यवस्थेचा विस्तार, जलनिस्सारणाची सुधारित
              व्यवस्था आणि सार्वजनिक ठिकाणांची सुशोभीकरण.
            </p>
          </div>
          <div className="card">
            <h3>शिक्षण व कौशल्य विकास</h3>
            <p>
              शाळांमधील गुणवत्तापूर्ण शिक्षण, डिजिटल साधनांचा वापर, युवक व महिला बचत गटांसाठी
              कौशल्यविकास प्रशिक्षण, करिअर मार्गदर्शन शिबिरे.
            </p>
          </div>
          <div className="card">
            <h3>आरोग्य व स्वच्छता</h3>
            <p>
              घराघरात शौचालय उपलब्धता, घनकचरा व्यवस्थापन, स्वच्छता मोहिमा, लसीकरण व आरोग्य शिबिरे
              नियमितपणे राबविणे.
            </p>
          </div>
          <div className="card">
            <h3>कृषी व उपजीविका</h3>
            <p>
              शेतकरी उत्पादक गट, शेतीमध्ये आधुनिक तंत्रज्ञानाचा वापर, पाणी बचत सिंचन पद्धती तसेच
              स्व-सहायता समूहांच्या माध्यमातून रोजगारनिर्मिती.
            </p>
          </div>
        </div>
      </section>

      <section className="container content">
        <h2>नागरिकांसाठी सेवा व सुविधा</h2>
        <p>
          ग्रामपंचायत कार्यालयातून नागरिकांना विविध दाखले, प्रमाणपत्रे तसेच ऑनलाइन सेवांचा लाभ
          उपलब्ध करून देण्यात येतो. आवश्यक कागदपत्रांसह कार्यालयात भेट देऊन खालील सेवा घेता येतात.
        </p>
        <div className="grid">
          <div className="card">
            <h3>दाखले व प्रमाणपत्रे</h3>
            <p>
              जन्म-मृत्यू दाखले, रहिवासी दाखला, उत्पन्न प्रमाणपत्रासाठी शिफारस, नातेदाखला आदीसाठी
              आवश्यक ती मार्गदर्शन व कागदपत्रे पाठविणे.
            </p>
          </div>
          <div className="card">
            <h3>कर व शुल्क भरणा</h3>
            <p>
              घरपट्टी, पाणीपट्टी, प्रकाशकर इत्यादी कर वेळेत भरण्यासाठी काऊंटर सुविधा तसेच हप्त्याने
              रक्कम भरण्याबाबत माहिती.
            </p>
          </div>
          <div className="card">
            <h3>तक्रार नोंद व सुचना</h3>
            <p>
              पाणीपुरवठा, रस्ता, स्वच्छता किंवा इतर कोणत्याही नागरी समस्येबाबत तक्रार नोंदविण्यासाठी
              ग्रामपंचायत कार्यालयात तक्रार नोंद वही तसेच सुचना पेटी उपलब्ध आहे.
            </p>
          </div>
        </div>
      </section>
      {/* <h1 style={{ marginTop: '100px' }}>This page is under development, please visit later...</h1> */}
    </div>
  );
};

export default Overview;
